export const moment = require('moment');
